import { useMutation } from '@tanstack/react-query';

import { partnersCampaignsApi } from '@/api/routes/partners/partners.campaigns.api';
import { downloadBlob } from '@/utils/file';

/** Downloads every contact of a campaign as CSV (UTF-8 with BOM, opens in Excel). */
export const usePartnersDownloadLeadsCsv = () => {
  return useMutation({
    mutationFn: async ({ id, filename }: { id: string; filename: string }) => {
      const { data } = await partnersCampaignsApi.leadsCsv(id);
      downloadBlob(data, filename);
    },
  });
};
